import axios from "@/lib/axios";

const getCancel = (custCode: string | undefined) => {
  return axios.get(`/facility/facility_agreements/terminate_cancels/${custCode}/cancel`);
}

export default getCancel;